import * as React from "react";

export const ArtistEarningsPage: React.FC = () => {
  return <section style={{ margin: "30px" }}></section>;
};
